import React from 'react';
import { arrayOf, oneOfType, string, bool } from 'prop-types';
import classNames from 'classnames';

import { propTypes } from '../../../util/types';
import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink, AvatarLarge } from '../../../components';

import css from './SectionSearchBySellers.module.css';

const SingleSeller = props => {
  const { user } = props;
  const { displayName } = user.attributes.profile;
  return (
    <NamedLink
      className={css.seller}
      name="ProfilePage"
      params={{
        id: user.id.uuid,
      }}
    >
      <AvatarLarge className={css.sellerAvatar} user={user} disableProfileLink />
      <h4 className={css.sellerTitle}>{displayName}</h4>
    </NamedLink>
  );
};

const SectionSearchBySellers = props => {
  const { className, rootClassName, users, fetchUsersInProgress, fetchUsersError } = props;
  const classes = classNames(rootClassName || css.root, className);

  if (fetchUsersInProgress || fetchUsersError || users.length === 0) {
    return null;
  }

  return (
    <div className={classes}>
      <h2 className={css.title}>
        <FormattedMessage id="LandingPage.SectionSearchBySellers.title" />
      </h2>
      <div className={css.sellers}>
        {users.map(u => (
          <SingleSeller key={u.id.uuid} user={u} />
        ))}
      </div>
      <NamedLink className={css.sectionLink} name="SearchUsersPage">
        <FormattedMessage id="LandingPage.SectionSearchBySellers.browseAllLink" />
      </NamedLink>
    </div>
  );
};

SectionSearchBySellers.defaultProps = {
  className: null,
  rootClassName: null,

  fetchUsersError: null,
  fetchUsersInProgress: false,
};

SectionSearchBySellers.propTypes = {
  className: string,
  rootClassName: string,

  users: arrayOf(oneOfType([propTypes.user, propTypes.currentUser])),
  fetchUsersInProgress: bool.isRequired,
  fetchUsersError: propTypes.error,
};

export default SectionSearchBySellers;
